
/* eslint-disable no-unused-vars */
import buttonHandler from "../buttonHandler";
declare global {
    interface Window extends Record<string, any> {
    }
}

interface ObservableReturnObject<V> {
    subscribe: (v: (v: V) => void) => () => void
    notify: (v: V) => void
}
const Observable = <V>(): ObservableReturnObject<V> => {
    const subscribers: Array<(v: V) => void> = [];

    return {
        subscribe: (subscriber) => {
            subscribers.push(subscriber);
            console.log('added subscriber', subscribers)
            return () => {
                const index = subscribers.indexOf(subscriber);
                console.log('remove subscriber', index)
                if (index !== -1) {
                    subscribers.splice(index, 1);
                }
            };
        },
        notify: (v) => {
            console.log('notifyyyy', v, subscribers)
            subscribers.forEach((subscriber) => {
                console.log('notify', subscriber)
                subscriber(v);
            });
        }
    };
};


interface IRecaptcha {
    execute: (v?: any) => Promise<string>
    ready: (cb: () => void) => void
    reset: (v: any) => void,
    render: (c: HTMLElement, p: {
        sitekey: string,
        hl: string,
        size: 'invisible'
        callback: (token: string) => void,
    }) => number
}

interface IRecaptchaModule {
    module: IRecaptcha,
    siteKey: string,
    language: string
}

interface IFormHandlerProps {
    form: HTMLFormElement,
    onSubmit: (e: SubmitEvent) => Promise<Response>
    onError?: (err: Response, form: [HTMLFormElement, HTMLElement, HTMLElement]) => void
    onSuccess?: (response: Awaited<Response> | null, form: [HTMLFormElement, HTMLElement, HTMLElement]) => void
    logs?: boolean
    recaptcha?: IRecaptchaModule

}

export class FormHandler implements IFormHandlerProps {
    unsubscribe?: any
    form: HTMLFormElement
    successElement: HTMLElement
    errorElement: HTMLElement
    onSubmit: (e: SubmitEvent) => Promise<Response>
    onError?: (err: Response, form: [HTMLFormElement, HTMLElement, HTMLElement]) => void
    onSuccess?: (response: Awaited<unknown> | null, form: [HTMLFormElement, HTMLElement, HTMLElement]) => void
    logs: boolean;
    recaptcha?: IRecaptchaModule
    recaptchaWidget: null | number = null;
    recaptchaObservable: ObservableReturnObject<string>;
    states = {
        loading: () => { },
        loaded: () => { }
    }
    constructor({ form, onSubmit, onError, onSuccess, logs = false, recaptcha }: IFormHandlerProps) {
        this.form = form
        this.onSubmit = onSubmit;
        this.onError = onError
        this.onSuccess = onSuccess
        this.logs = logs;
        this.recaptcha = recaptcha;
        this.successElement = this.form.nextSibling as HTMLElement;
        this.errorElement = this.successElement.nextSibling as HTMLElement;

        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleOnSucces = this.handleOnSucces.bind(this);
        this.handleOnError = this.handleOnError.bind(this);
        this._waitForCloseRecaptcha = this._waitForCloseRecaptcha.bind(this);
        this._verify = this._verify.bind(this)
        this.renderRecaptcha = this.renderRecaptcha.bind(this)
        this.log = this.log.bind(this)

        const [loading, loaded] = buttonHandler(this.form)
        this.states = { loading, loaded };

        this.form.addEventListener("submit", this.handleOnSubmit)
    }

    renderRecaptcha() {
        if (!this.recaptcha) {
            this.log('no recaptcha module', this.recaptcha)
            return Promise.resolve()
        }
        this.log('recaptcha module', this.recaptcha.module)
        const recaptchaKey = `recaptchaWidget${this.recaptcha.language}${this.recaptcha.siteKey}` as any
        this.log('recaptchaKey', recaptchaKey)
        if (window[recaptchaKey] === undefined) {

            this.log('new recaptchaKey');
            const container = document.createElement('div');
            document.body.append(container);

            const observable = Observable()
            //@ts-ignore
            const recaptchaWidgetId = this.recaptcha.module.render(container, {
                sitekey: this.recaptcha.siteKey,
                hl: this.recaptcha.language,
                size: "invisible",
                callback: (token: string) => {
                    console.log('callback', token)
                    observable.notify(token)
                }
            })


            //@ts-ignore
            window[recaptchaKey] = {
                id: recaptchaWidgetId,
                observable: observable
            }
        }
        if (!this.recaptchaWidget) this.recaptchaWidget = window[recaptchaKey].id;
        if (!this.recaptchaObservable) this.recaptchaObservable = window[recaptchaKey].observable
        this.log('recaptchaWidget', this.recaptchaWidget)
        this.log('recaptchaObservable', this.recaptchaObservable)
        return new Promise((res) => { this.recaptcha.module.ready(() => res('')) })
    }
    log(...args: unknown[]) {
        if (this.logs) console.log(args);
    }
    handleOnError(err?: Response) {
        this.log('handleOnError', err)
        const errorElement = this.errorElement;

        this.log('errorElement', errorElement)
        if (errorElement && errorElement.style) {
            errorElement.style.display = 'block';

        }
        if (this.recaptcha) this.recaptcha.module.reset(this.recaptchaWidget)

        this.onError?.(err, [this.form, this.successElement, this.errorElement])
    }

    handleOnSucces(response: Response) {
        this.log('handleOnSucces', response);
        const successElement = this.successElement;
        const errorElement = this.errorElement;

        this.log('errorElement', errorElement)
        this.log('successElement', successElement)

        this.form.style.display = 'none';

        if (successElement && successElement.style) {
            successElement.style.display = 'block';
        }
        if (errorElement && errorElement.style) {
            errorElement.style.display = 'none';
        }

        if (this.recaptcha) this.recaptcha.module.reset(this.recaptchaWidget);

        this.onSuccess?.(response, [this.form, this.successElement, this.errorElement])
    }

    async handleOnSubmit(e: SubmitEvent) {
        this.log('handleOnSubmit', e)
        e.preventDefault();

        this.states.loading()

        if (this.recaptcha) {
            this.log('recaptcha')
            try {
                const token = await this._verify();
                this.log('token', token)

                //canceled
                if (!token) return this.states.loaded()

                let input = this.form.querySelector('input[name="grecaptcha"]') as HTMLInputElement || null
                if (!input) {
                    input = document.createElement('input')
                    input.setAttribute('name', 'grecaptcha')
                    input.style.display = 'none';
                    this.form.append(input)
                }
                //@ts-ignore
                input.value = token

                this.log('input', input)

            } catch (err) {
                this.states.loaded()
                throw err
            }
        }
        this.triggerSubmit(e)
    }

    async triggerSubmit(e: SubmitEvent) {
        this.log('triggerSubmit', e)
        try {
            const response = await this.onSubmit(e)
            const isHttpResponse = response instanceof Response

            if (!isHttpResponse) {
                this.handleOnSucces(response);
                return response;
            }

            if (response.ok) {
                this.handleOnSucces(response)
            } else {
                this.handleOnError(response)
            }

            return response
        } catch (err) {
            this.handleOnError(err)
        }
        finally { this.states.loaded() }
    }

    private async _wait(time = 100) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve('');
            }, time);
        });
    }

    private executeRecaptcha = () => {

        return new Promise(res => {
            this.recaptcha.module.execute(this.recaptchaWidget);
            this.unsubscribe = this.recaptchaObservable.subscribe((token: string) => {
                console.log('subscribe token')
                res(token);
            })
        })
    }
    private async _verify() {
        await this.renderRecaptcha();
        const promiseToken = this.executeRecaptcha()
        const promiseClosedRecaptchaByUser = this._waitForCloseRecaptcha()
        const token = await Promise.race([promiseToken, promiseClosedRecaptchaByUser])
        this.unsubscribe?.()
        this.log('recaptchaToken', token)

        return token
    }

    private async _waitForCloseRecaptcha(counter = 0): Promise<unknown> {
        if (counter > 60) {
            console.log('counter > 60');
            return Promise.resolve('')
        }
        const iframes = document.querySelectorAll(
            "iframe[src*='google.com/recaptcha/api2/bframe'"
        );
        const recaptchaWindow = Array.from(iframes).find(iframe => {
            const container = iframe.parentNode.parentNode as HTMLElement;
            return container.style.visibility === 'visible';
        });


        if (!recaptchaWindow) {
            await this._wait();
            return this._waitForCloseRecaptcha(counter + 1);
        }


        return new Promise(async (resolve) => {
            if (recaptchaWindow) {
                console.log('recaptchaWindow exist', recaptchaWindow)
                const container = recaptchaWindow.parentNode.parentNode as HTMLElement;
                const observer = new MutationObserver((_, observer) => {
                    if (container.style?.visibility === 'hidden') {
                        this.log('recaptchaWindow hidden')
                        observer.disconnect();
                        setTimeout(() => resolve(''), 1000)
                    }
                });
                observer.observe(container, {
                    attributeFilter: ['style'],
                    // subtree: true,
                    // childList: true,
                });
            }
        });
    }
}

